import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { downloadFormDocument } from '../../../api/documents';
import type { FormType } from '../../../api/forms';
import { DocumentLanguageSelect, DownloadButtons, defaultDocumentLanguage } from './DocumentDownloads';

/** PDF/DOCX downloads of a status form (filled in, or blank and printable while there are no values). */
export function FormDocuments({ inspectionId, formType, title }: { inspectionId: string; formType: FormType; title: string }) {
  const { t } = useTranslation();
  const [lang, setLang] = useState(defaultDocumentLanguage);
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className="govuk-!-margin-top-8">
      <h2 className="govuk-heading-m" id={headingId}>
        {t('documents.formHeading')}
      </h2>
      <p className="govuk-body">{t('documents.formIntro')}</p>
      <DocumentLanguageSelect id={`doc-${formType}-lang`} value={lang} onChange={setLang} />
      <DownloadButtons id={`doc-${formType}`} name={title} lang={lang} onDownload={(format, l) => downloadFormDocument(inspectionId, formType, format, l)} />
    </section>
  );
}
